export function getOrganizationLogoUrl(url: string, size: 48 | 192): string {
  try {
    const parsed = new URL(url);
    parsed.pathname = parsed.pathname.replace(
      /^(\/api\/images\/org-logos\/[^/]+\/[^/]+\/)orglogo-(?:48|192)\//,
      `$1orglogo-${size}/`,
    );
    return parsed.href;
  } catch {
    return url;
  }
}
